import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TranscriptSearchNavigationButtons = () => {
  const {
    handleSelectResult,
    selectedResultIndex,
    totalMatches
  } = useContext(TranscriptContext);
  const handleNextClick = () => {
    handleSelectResult(selectedResultIndex + 1);
  };
  const handlePreviousClick = () => {
    handleSelectResult(selectedResultIndex - 1);
  };
  return totalMatches !== 0 ? /*#__PURE__*/_jsxs(Flex, {
    alignItems: "stretch",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(IconButton, {
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.searchBarNavigation.searchPrevious"
      }),
      placement: "top",
      use: "link",
      marginBlock: "auto",
      "data-test-id": "searchNav-previousBtn",
      onClick: handlePreviousClick,
      disabled: selectedResultIndex === 0,
      children: /*#__PURE__*/_jsx(LeftIcon, {
        size: "300"
      })
    }), /*#__PURE__*/_jsxs(Text, {
      as: "h5",
      paddingBlock: "300",
      marginBlockEnd: "0",
      textAlign: "center",
      "data-test-id": "transcript-SearchResultCount",
      children: [selectedResultIndex + 1, "/", totalMatches]
    }), /*#__PURE__*/_jsx(IconButton, {
      use: "link",
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.searchBarNavigation.searchNext"
      }),
      placement: "top",
      marginBlock: "auto",
      "data-test-id": "searchNav-nextBtn",
      onClick: handleNextClick,
      disabled: selectedResultIndex >= totalMatches - 1,
      children: /*#__PURE__*/_jsx(RightIcon, {
        size: "300"
      })
    })]
  }) : /*#__PURE__*/_jsx(Text, {
    as: "h5",
    whiteSpace: "nowrap",
    marginBlockEnd: "0",
    paddingBlock: "300",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.transcript.searchBarNavigation.notFound"
    })
  });
};